import React, { Suspense, lazy, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import store from '../store'
import '../styles/main.css'
import Header from './Header'
import Footer from './Footer'
import UluleButton from './UluleButton'

const Home = lazy(() => import('../pages/Home'))
const Admin = lazy(() => import('../pages/Admin'))
const EmailPreview = process.env.NODE_ENV === 'development'
  ? lazy(() => import('../pages/EmailPreview'))
  : null

function AppRouter () {
  useEffect(() => {
    store.initStore()
  })

  return (
    <Router>
      <Routes>
        <Route path='/admin' element={
          <Suspense fallback={null}>
            <Admin />
          </Suspense>
        } />
        {EmailPreview && (
          <Route path='/test/email/new' element={
            <Suspense fallback={null}>
              <EmailPreview />
            </Suspense>
          } />
        )}
        <Route path='/*' element={
          <div className='min-h-screen'>
            <Header />
            <div className='flex flex-col items-center'>
              <Suspense fallback={<>Loading...</>}>
                <Home />
              </Suspense>
            </div>
            <Footer />
            <UluleButton />
          </div>
        } />
      </Routes>
    </Router>
  )
}

export default AppRouter
